import { Box, Divider, Typography } from "@mui/material";
import {
  ROAD_CLASS_CODE_MAP,
  ROAD_WIDTH_CODE_MAP,
} from "@/features/map/constants/roadLayer";

interface RoadPopupContentProps {
  // 道路分類のコード値（国土数値情報 N13_003）
  roadClassCode?: string;
  // 幅員区分のコード値（国土数値情報 N13_006）
  roadWidthCode?: string;
}

// コード値を日本語ラベルに変換する。
// マップに無いコードが来た時は、原因調査のためコード値を併記して「不明」として出す
const getRoadClassLabel = (code?: string): string => {
  if (!code) return "不明";
  return ROAD_CLASS_CODE_MAP[code] ?? `不明 (${code})`;
};

const getRoadWidthLabel = (code?: string): string => {
  if (!code) return "不明";
  return ROAD_WIDTH_CODE_MAP[code] ?? `不明 (${code})`;
};

/*
道路をクリックした時に出るポップアップの中身。
表示中のモード（分類種別 / 幅員）に関わらず、両方の情報を並べて出す
*/
export const RoadPopupContent: React.FC<RoadPopupContentProps> = ({
  roadClassCode,
  roadWidthCode,
}) => {
  return (
    <Box sx={{ minWidth: 260, p: 1 }}>
      <Typography variant="subtitle1" fontWeight={700} gutterBottom>
        道路データ
      </Typography>
      <Divider sx={{ mb: 1.5 }} />
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        <strong>道路分類種別:</strong> {getRoadClassLabel(roadClassCode)}
      </Typography>
      <Typography variant="body2">
        <strong>幅員区分:</strong> {getRoadWidthLabel(roadWidthCode)}
      </Typography>
    </Box>
  );
};
